import Axios from 'axios'
import { getHeadersWithJwtToken } from 'auth/utils/auth-util'
import { apiRoutes } from 'constants/routes'
import { ISupportData } from 'interfaces/i-api-support'

const supportService = {
	async sendEmail(email: ISupportData) {
		const { data } = await Axios.post(
			apiRoutes.sendEmail,
			email,
			await getHeadersWithJwtToken()
		)
		return data
	},
}
export default supportService